import { jsxs as n, jsx as e } from "react/jsx-runtime";
import { getMainIconProps as l } from "./index.es2361.js";
function V(i) {
  const { outline: t, fill: o, size: C } = l(i);
  return /* @__PURE__ */ n(
    "svg",
    {
      width: C,
      height: C,
      viewBox: "0 0 18 18",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "data-testid": "locked-icon",
      children: [
        /* @__PURE__ */ e(
          "path",
          {
            shapeRendering: "optimizeQuality",
            d: "M1 10C1 8.89543 1.89543 8 3 8H15C16.1046 8 17 8.89543 17 10V16C17 17.1046 16.1046 18 15 18H3C1.89543 18 1 17.1046 1 16V10Z",
            fill: o
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            shapeRendering: "optimizeQuality",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4 8V5C4 2.23857 6.23858 0 9 0C11.7614 0 14 2.23858 14 5V8H15C16.1046 8 17 8.89543 17 10V16C17 17.1046 16.1046 18 15 18H3C1.89543 18 1 17.1046 1 16V10C1 8.89543 1.89543 8 3 8H4ZM13.25 7.99V5C13.25 2.65279 11.3472 0.75 9 0.75C6.65279 0.75 4.75 2.65279 4.75 5V7.99H6.5V5C6.5 3.61929 7.61929 2.5 9 2.5C10.3807 2.5 11.5 3.61929 11.5 5V7.99H13.25ZM7.25 5V7.99H10.75V5C10.75 4.0335 9.9665 3.25 9 3.25C8.0335 3.25 7.25 4.0335 7.25 5ZM16.25 10C16.25 9.30964 15.6904 8.75 15 8.75H3C2.30964 8.75 1.75 9.30964 1.75 10V16C1.75 16.6904 2.30964 17.25 3 17.25H15C15.6904 17.25 16.25 16.6904 16.25 16V15H12.375C12.1679 15 12 14.8321 12 14.625C12 14.4179 12.1679 14.25 12.375 14.25H16.25V13H12.375C12.1679 13 12 12.8321 12 12.625C12 12.4179 12.1679 12.25 12.375 12.25H16.25V11H12.375C12.1679 11 12 10.8321 12 10.625C12 10.4179 12.1679 10.25 12.375 10.25H16.25V10Z",
            fill: t
          }
        )
      ]
    }
  );
}
V.__tags = [];
export {
  V as LockIcon
};
//# sourceMappingURL=index.es295.js.map
